import styled from 'styled-components';
import { Typography, TypographyType, TypographyWeight } from '../../../style/Typography';

const legendHeight = 18;
export const LegendContainer = styled.div.attrs({
  className: 'chart-default-legend'
})``;

export const Title = styled.div`
  font-size: 12px;
  color: var(--lightGrey);
  padding: 0px 7px 10px 7px;
`;

export const LegendWrapper = styled.div.attrs({
  className: 'chart-legend-wrapper'
})`
  max-height: 105px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 6px 10px;
`;

export const Legend = styled.div.attrs({
  className: 'chart-legend-entry'
})`
  display: flex;
  background-color: ${({ isActive }) => isActive && 'var(--legend-active-bg-color)'};
  border: ${({ $isPartial }) => ($isPartial ? 'dashed 1px var(--legend-active-color)' : 'dashed 1px transparent')};
  box-sizing: border-box;
  /* Hover has no active background, so it needs its own tone where active text is inverse. */
  color: ${({ isActive, isHover }) => {
    if (isActive) return 'var(--legend-active-color)';
    return isHover ? 'var(--legend-hover-color, var(--legend-active-color))' : 'var(--legend-color)';
  }};
  padding: 0 7px;
  border-radius: var(--main-card-radius);
  cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
  align-items: center;
  min-height: ${`${legendHeight}px`};
  max-height: 29px;
  justify-content: space-between;
  gap: 10px;
  min-width: ${({ $legendWidth }) => !$legendWidth && '125px'};
  width: ${({ $legendWidth }) => $legendWidth && `${$legendWidth}px`};
`;
export const LegendColor = styled.div`
  background: ${({ color }) => color || 'var(--royalBlue)'};
  width: 8px;
  height: 8px;
  border-radius: 4px;
`;

export const SkeletonWrapper = styled.div`
  flex: 1;
  padding: 0 7px;
  border-radius: 20px;
  height: ${`${legendHeight}px`};
  width: ${({ $legendWidth }) => $legendWidth && `${$legendWidth}px`};
  min-width: ${({ $legendWidth }) => !$legendWidth && '125px'};
  .MuiSkeleton-root {
    //background-color: var(--midnight); // color inherited from theme-colors.js based on var(--skeleton-color)
    width: ${({ $legendWidth }) => $legendWidth && `${$legendWidth}px`};
  }
`;

export const LegendTextWrapper = styled.div`
  height: 100%;
  display: flex;
  gap: 10px;
  flex: 1;
  align-items: center;
  justify-content: space-between;
`;

export const LegendText = styled(Typography).attrs({
  type: TypographyType.B2C,
  weight: TypographyWeight.REGULAR
})`
  max-width: 125px;
  text-shadow: ${({ isActive }) =>
    isActive ? 'var(--legend-active-text-shadow, 0 0 1px var(--darkJungleGreen))' : 'unset'};
  overflow: hidden;
  white-space: normal;

  @media (min-width: 1280px) and (max-width: 1919px) {
    max-width: 120px;
  }
`;
export const LegendToolTip = styled.span.attrs({ className: 'text-s' })``;
export const LegendNumber = styled(Typography).attrs({
  type: TypographyType.B2C,
  weight: TypographyWeight.REGULAR
})`
  text-shadow: ${({ isActive }) =>
    isActive ? 'var(--legend-active-text-shadow, 0 0 1px var(--darkJungleGreen))' : 'unset'};
`;
